"use strict";
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _Garden_address, _Garden_connector;
Object.defineProperty(exports, "__esModule", { value: true });
const types_1 = require("../types");
const helpers_1 = require("../helpers");
class Garden {
    /**
     * Create a new Garden instance.
     * @param connector A GardenConnector instance.
     * @param address The garden address.
     */
    constructor(connector, address) {
        _Garden_address.set(this, void 0);
        _Garden_connector.set(this, void 0);
        __classPrivateFieldSet(this, _Garden_connector, connector, "f");
        __classPrivateFieldSet(this, _Garden_address, address, "f");
    }
    /**
     * Close the connection.
     */
    async disconnect() {
        await __classPrivateFieldGet(this, _Garden_connector, "f").disconnect();
    }
    /**
     * Fetch the configuration of the garden.
     * @returns A promise that resolves to the configuratio of the garden.
     */
    config() {
        return __classPrivateFieldGet(this, _Garden_connector, "f").config(__classPrivateFieldGet(this, _Garden_address, "f"));
    }
    /**
     * Subscribe to updates in the configuration of the garden.
     * @param callback A function callback to postprocess the result.
     * @returns A GraphQL subsription to the configuratio of the garden.
     */
    onConfig(callback) {
        return __classPrivateFieldGet(this, _Garden_connector, "f").onConfig(__classPrivateFieldGet(this, _Garden_address, "f"), callback);
    }
    /**
     * Fetch a proposal of the garden.
     * @param params
     * @param params.number The proposal identification number.
     * @param params.appAddress The address of the Aragon application that have created the proposals.
     * @returns A promise that resolves to a proposal of the garden.
     */
    async proposal({ number = '', appAddress = '' } = {}) {
        const proposalId = (0, helpers_1.buildProposalId)(parseInt(number), appAddress);
        return __classPrivateFieldGet(this, _Garden_connector, "f").proposal(proposalId);
    }
    /**
     * Subscribe to updates in a proposal of the garden.
     * @param params
     * @param params.number The proposal identification number.
     * @param params.appAddress The address of the Aragon application that have created the proposals.
     * @param callback A function callback to postprocess the result.
     * @returns A GraphQL subsription to a proposal of the garden.
     */
    onProposal({ number = '', appAddress = '' } = {}, callback) {
        const proposalId = (0, helpers_1.buildProposalId)(parseInt(number), appAddress);
        return __classPrivateFieldGet(this, _Garden_connector, "f").onProposal(proposalId, callback);
    }
    /**
     * Fetch a list of proposals of the garden.
     * @param params A filters object.
     * @param params.first Number of entities to return.
     * @param params.skip Number of entities to skip.
     * @param params.orderBy Filter to order the results.
     * @param params.orderDirection Direction to order the results.
     * @param params.types Filter by proposal type.
     * @param params.statuses Filter by proposal status.
     * @param params.metadata Filter by proposal name.
     * @returns A promise that resolves to a list of proposals of the garden.
     */
    async proposals({ first = 1000, skip = 0, orderBy = 'createdAt', orderDirection = 'desc', types = types_1.ALL_PROPOSAL_TYPES, statuses = types_1.ALL_PROPOSAL_STATUSES, metadata = '', } = {}) {
        return __classPrivateFieldGet(this, _Garden_connector, "f").proposals(__classPrivateFieldGet(this, _Garden_address, "f"), first, skip, orderBy, orderDirection, types, statuses, metadata);
    }
    /**
     * Subscribe to updates of a list of proposals of the garden.
     * @param params A filters object.
     * @param params.first Number of entities to return.
     * @param params.skip Number of entities to skip.
     * @param params.orderBy Filter to order the results.
     * @param params.orderDirection Direction to order the results.
     * @param params.types Filter by proposal type.
     * @param params.statuses Filter by proposal status.
     * @param params.metadata Filter by proposal name.
     * @returns A GraphQL subsription to a list of proposals of the garden.
     */
    onProposals({ first = 1000, skip = 0, orderBy = 'createdAt', orderDirection = 'desc', types = types_1.ALL_PROPOSAL_TYPES, statuses = types_1.ALL_PROPOSAL_STATUSES, metadata = '', } = {}, callback) {
        return __classPrivateFieldGet(this, _Garden_connector, "f").onProposals(__classPrivateFieldGet(this, _Garden_address, "f"), first, skip, orderBy, orderDirection, types, statuses, metadata, callback);
    }
    /**
     * Fetch a supporter of the garden.
     * @param params
     * @param params.id The identifier of the supporter to fetch.
     * @returns A promise that resolves to a supporter of the garden.
     */
    async supporter({ id = '' } = {}) {
        const supporterId = (0, helpers_1.buildSupporterId)(id, __classPrivateFieldGet(this, _Garden_address, "f"));
        return __classPrivateFieldGet(this, _Garden_connector, "f").supporter(supporterId);
    }
    /**
     * Subscribe to updates in a supporter of the garden.
     * @param params
     * @param params.id The identifier of the supporter to fetch.
     * @param callback A function callback to postprocess the result.
     * @returns A GraphQL subsription to a supporter of the garden.
     */
    onSupporter({ id = '' } = {}, callback) {
        const supporterId = (0, helpers_1.buildSupporterId)(id, __classPrivateFieldGet(this, _Garden_address, "f"));
        return __classPrivateFieldGet(this, _Garden_connector, "f").onSupporter(supporterId, callback);
    }
}
exports.default = Garden;
_Garden_address = new WeakMap(), _Garden_connector = new WeakMap();
